import React, { useState, useEffect } from 'react';
import ReactRecaptcha, { RecaptchaProps } from 'react-recaptcha';

import { useCurrentLanguage, useScript } from '@lib/hooks';
import configService from '@lib/services/configService';

interface Props extends RecaptchaProps {}

export default function Recaptcha(props: Props) {
  const language = useCurrentLanguage();
  const [key, setKey] = useState(0);
  const [loaded] = useScript('//www.google.com/recaptcha/api.js');

  // NOTE: Need to use language instead of locale b/c Recaptcha doesn't support en-US | es-US
  // https://developers.google.com/recaptcha/docs/language

  useEffect(() => {
    setKey((prevState) => prevState + 1);
  }, [setKey, language]);

  if (!loaded) {
    return <React.Fragment />;
  }

  return (
    <ReactRecaptcha
      sitekey={configService.getKeyRecaptcha()}
      render="explicit"
      hl={language}
      key={key}
      // WORKAROUND: https://github.com/appleboy/react-recaptcha/issues/231#issuecomment-383533303
      onloadCallback={() => {}}
      {...props}
    />
  );
}
